const bazarPk = {
	common: {
		brandLabel: 'برانڈ',
		storeLabel: 'دکان',
		unitCount: '',
	},
	search: {
		placeholders: [
			'پروڈکٹ کا نام لکھیں...',
			'برانڈ کا نام لکھیں...',
			'دکان کا نام لکھیں...',
			'کیٹیگری کا نام لکھیں...'
		]
	},
	sidebar: {
		categoriesTitle: 'کیٹیگریز',
		storesTitle: 'دکانوں کی فہرست',
	},
	store: {
		serviceAreaLabel: 'سروس ایریا',
		nationwide: 'پورے ملک میں',
		productCount: 'مصنوعات',
		productsOfSuffix: 'کے مصنوعات',
		description: 'اس دکان کی تمام دستیاب اشیاء نیچے دکھائی گئی ہیں۔ آپ کیٹیگری کے لحاظ سے فلٹر کر سکتے ہیں۔',
	},
	buttons: {
		details: 'تفصیل',
		addToCart: 'کارٹ میں شامل کریں',
		clearFilters: 'تمام فلٹر صاف کریں',
		close: 'بند کریں',
	},
	empty: {
		title: 'کوئی پروڈکٹ نہیں ملی',
		subtitle: 'براہ کرم اپنے فلٹر یا تلاش کو تبدیل کریں',
	},
};

export default bazarPk;


